// Google Analytics 4 event tracking utilities

declare global {
  interface Window {
    gtag: (...args: unknown[]) => void;
    dataLayer: unknown[];
  }
}

export const GA_MEASUREMENT_ID = 'G-6K70PGV33F';

export const trackEvent = (eventName: string, params?: Record<string, unknown>) => {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('event', eventName, params);
  }
};

export const trackWhatsAppClick = (source: string, details?: string) => {
  trackEvent('whatsapp_click', {
    event_category: 'conversion',
    event_label: source,
    details,
  });
};

export const trackFormSubmission = (formData?: Record<string, unknown>) => {
  trackEvent('reservation_form_submit', {
    event_category: 'conversion',
    event_label: 'booking_form',
    ...formData,
  });
};
